<!--  -->
<template>
  <div class="header">
    <div style="width:1210px;margin:0 auto;">
      <div class="box">
        <img class="logo" src="../assets/logo2x.png" alt />
        <el-menu
          mode="horizontal"
          text-color="#fff"
          active-text-color="#fff"
          background-color="transparent"
        >
          <el-menu-item>
            <router-link to="/">首页</router-link>
          </el-menu-item>
          <el-menu-item>
            <a href="/subscribe">招标订阅</a>
          </el-menu-item>
          <el-menu-item>
            <a href="/find">招标搜索</a>
          </el-menu-item>
          <el-menu-item class="customMade">
            <a href="/customMade">定制服务 <img src="@/assets/programme/shouye-new.png" alt=""></a>
          </el-menu-item>
          <el-menu-item>
            <a href="/payOption">数据导出</a>
          </el-menu-item>
          <el-menu-item>
            <a href="/findInfo">行业资讯</a>
          </el-menu-item>
          <el-menu-item>
            <a href="/order">翻译服务</a>
          </el-menu-item>
        </el-menu>
      </div>
      <!-- margin-left:365px; -->
      <div class="box" style="margin-right: 0px;margin-left: 256px;">
        <transition name="fade">
          <div
            class="search"
            style="background:#fff;border-radius: 6px;position: absolute;top:10px;right:80px;"
            v-show="inpShow"
          >
            <el-select v-model="toWhere" placeholder="请选择">
              <el-option
                v-for="item in infoOrTender"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-divider direction="vertical"></el-divider>
            <el-input placeholder="请输入内容" v-model="input1" @keyup.enter.native="onSubmit">
              <i class="el-icon-search" slot="suffix" style="cursor: pointer;" @click="onSubmit"></i>
            </el-input>
          </div>
        </transition>
        <el-button @click="openLogin()" v-show="!showuser">登录</el-button>
        <el-popover
          placement="bottom"
          width="210"
          trigger="click"
          v-show="showuser"
          ref="popverRef"
        >
          <div class="head">
            <el-avatar
              class="headImg"
              slot="reference"
              :size="40"
              :src="userInfo.spareusero"
              fit="cover"
            ></el-avatar>
            <div>
              <p class="username">{{ this.userInfo.username }}</p>
            </div>
          </div>
          <ul class="list">
            <li @click="goto(index)" v-for="(item, index) in navList" :key="index">
              <i :class="item.icon"></i>
              {{ item.name }}
            </li>
            <li @click="goto(4)">
              <i class="el-icon-sort" style="transform:rotate(90deg);margin-right:9px"></i>我的翻译
            </li>
            <li @click="signout">
              <i class="el-icon-switch-button"></i>退出登录
            </li>
          </ul>
          <el-avatar
            class="headImg"
            slot="reference"
            :size="40"
            :src="userInfo.spareusero"
            style="margin-left: 30px;vertical-align: middle;"
            fit="cover"
          ></el-avatar>
        </el-popover>
      </div>
      <login :visible.sync="dialogFormVisible" @result="result"></login>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import login from '../components/login.vue'
import tool from '../tool/tool'
import { API_1, Global } from '@/conf/api'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'multi',
  props: ['inp', 'info'],
  components: { login },
  data() {
    //这里存放数据
    return {
      circleUrl:
        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      toWhere: 2, //选择去资讯还是招标
      infoOrTender: [
        { id: 1, value: '资讯' },
        { id: 2, value: '招标' },
      ],
      activeIndex: '1', //导航栏active
      inpShow: true, //搜索框显示
      showuser: null, //用户信息显示
      userInfo: {}, //子组件返回用户信息
      input1: '', //header搜索框
      dialogFormVisible: false, //登录框显示or隐藏
      phone: '',
      email: '',
      phoneCode: '', //手机验证
      emailCode: '', //邮箱验证码
      disabled: true, //验证码按钮可用状态
      count: '', //显示时的文字内容
      timer: null, //验证码倒计时
      beginClientX: 0 /*距离屏幕左端距离*/,
      mouseMoveStata: false /*触发拖动状态  判断*/,
      maxwidth: '' /*拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: '拖动滑块验证' /*滑块文字*/,
      confirmSuccess: false /*验证成功判断*/,
      activeName: '1', //默认tabs
      uid: null,
      token: null,
      navList: [
        {
          icon: 'el-icon-user',
          name: '个人资料',
          path: 'user',
        },
        {
          icon: 'el-icon-collection',
          name: '我的订阅',
          path: 'subscribe',
        },
        {
          icon: 'el-icon-data-line',
          name: '导出记录',
          path: 'mydata',
        },
        {
          icon: 'el-icon-star-off',
          name: '我的收藏',
          path: 'collect',
        },
      ],
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    inp(a, b) {
      this.inpShow = a
    },
    uid(a, b) {},
    info(a, b) {
      this.userInfo = a
    },
  },
  //方法集合
  methods: {
    goto(index) {
      let obj = {
        0: 'user',
        1: 'subscribe',
        2: 'mydata',
        3: 'collect',
        4: 'mytranslate',
      }
      this.$router.push({ name: obj[index] })
      this.$refs.popverRef.doClose()
    },
    signout() {
      tool.saveCookie('qxchuhai', '', -1)
      tool.saveCookie('user', '', -1)
      this.$refs.popverRef.doClose()
      this.showuser = false
      if (
        this.$route.path == '/subscribe' ||
        this.$route.path == '/user' ||
        this.$route.path == '/mydata' ||
        this.$route.path == '/collect'
      ) {
        this.$router.push({
          path: '/',
        })
      } else {
        location.reload()
      }
    },
    result(val) {
      if (val) {
        this.showuser = true
      }
      if (val.wx == 1) {
        let params = this.$qs.stringify({
          id: tool.getCookie('user'),
          code: tool.getCookie('qxchuhai'),
        })
        this.axios
          .post(API_1 + Global.userInfo, params, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })
          .then((res) => {
            this.userInfo = res.data.data
          })
          .catch((res) => {
            this.$message({
              message: '网络连接失败，请刷新重试',
              type: 'error',
              offset: 100,
            })
          })
      } else {
        this.userInfo = val
      }

      // this.userInfo.spareusero =
      //   API_1 + Global.imgUrl + this.userInfo.spareusero
      if (this.userInfo.username == null) {
        this.userInfo.username == '游客'
      }
    },
    login(type) {
      if (type == 1) {
        //手机验证码
        let params = {
          phone: this.phone,
          code: this.phoneCode,
        }
        this.axios
          .post(API_1 + Global.phoneCode, params)
          .then((res) => {
            this.$message({
              message: '登录成功，欢迎您',
              type: 'success',
            })
          })
          .catch((res) => {
            this.$message.error('登录失败，请稍后再试')
          })
      } else if (type == 2) {
        //邮箱验证码
        let params = {
          code: this.emailCode,
          useremail: this.email,
        }
        this.axios
          .post(API_1 + Global.emailCode, params)
          .then((res) => {
            this.$message({
              message: '登录成功，欢迎您',
              type: 'success',
            })
          })
          .catch((res) => {
            this.$message.error('登录失败，请稍后再试')
          })
      }
    },
    getCode(type) {
      //点击获取验证码
      this.disabled = true
      const TIME_COUNT = 10 //倒计时60秒
      if (!this.timer) {
        this.count = TIME_COUNT
        this.codeShow = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.codeShow = true
            clearInterval(this.timer)
            this.timer = null
            this.disabled = false
          }
        }, 1000)
        if (type == 1) {
          //手机验证码
          let params = this.$qs.stringify({
            phone: this.phone,
          })
          this.axios
            .post(API_1 + Global.phone, params)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message({
                  message: '发送成功，请注意查收验证码',
                  type: 'success',
                  offset: 50,
                })
              } else {
                this.$message({
                  message: '发送失败，请稍后再试',
                  type: 'error',
                  offset: 50,
                })
              }
            })
            .catch((res) => {
              this.$message.error('发送失败，请稍后再试')
            })
        } else if (type == 2) {
          //邮箱验证码
          let params = {
            useremail: this.email,
          }
          this.axios
            .post(API_1 + Global.email, params)
            .then((res) => {
              this.$message({
                message: '发送成功，请注意查收验证码',
                type: 'success',
              })
            })
            .catch((res) => {
              this.$message.error('发送失败，请稍后再试')
            })
        }
      }
    },
    openLogin() {
      this.dialogFormVisible = true
    },
    phoneMessage() {
      if (this.phone === '') {
        this.$message({
          showClose: true,
          message: '手机号不能为空',
          type: 'warning',
        })
      } else {
        if (this.phone !== '') {
          let reg = /^1[23456789]\d{9}$/
          if (!reg.test(this.phone)) {
            this.$message({
              showClose: true,
              message: '请输入有效手机格式',
              type: 'warning',
            })
          } else {
            this.disabled = false
          }
        }
      }
    },
    emailMessage() {
      if (this.email === '') {
        this.$message({
          showClose: true,
          message: '邮箱不能为空',
          type: 'warning',
        })
      } else {
        if (this.email !== '') {
          let reg =
            /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (!reg.test(this.email)) {
            this.$message({
              showClose: true,
              message: '请输入有效的邮箱格式',
              type: 'warning',
            })
          } else {
            this.disabled = false
          }
        }
      }
    },
    onSubmit() {
      //跳转搜索页
      if (this.toWhere == 1) {
        //资讯
        this.$router.push({
          path: 'findInfo',
          query: { keyWord: this.input1 },
        })
      } else {
        //招标
        this.$router.push({
          path: 'find',
          query: { keyWord: this.input1 },
        })
      }
    },
    mousedownFn: function (e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault() //阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true
        this.beginClientX = e.clientX
      }
    }, //mousedoen 事件
    successFunction() {
      this.confirmSuccess = true
      this.confirmWords = '验证通过'
      if (window.addEventListener) {
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mousemove', this.mouseMoveFn)
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mouseup', this.moseUpFn)
      } else {
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mouseup', () => {})
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      document.getElementsByClassName('handler')[0].style.left =
        this.maxwidth + 'px'
      document.getElementsByClassName('drag_bg')[0].style.width =
        this.maxwidth + 'px'
    }, //验证成功函数
    mouseMoveFn(e) {
      if (this.mouseMoveStata) {
        let width = e.clientX - this.beginClientX
        if (width > 0 && width <= this.maxwidth) {
          document.getElementsByClassName('handler')[0].style.left =
            width + 'px'
          document.getElementsByClassName('drag_bg')[0].style.width =
            width + 'px'
        } else if (width > this.maxwidth) {
          this.successFunction()
        }
      }
    },
    moseUpFn(e) {
      this.mouseMoveStata = false
      var width = e.clientX - this.beginClientX
      if (width < this.maxwidth) {
        document.getElementsByClassName('handler')[0].style.left = 0 + 'px'
        document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px'
      }
    },
    getuserInfo() {
      let params = this.$qs.stringify({
        id: this.uid,
        code: this.token,
      })
      this.axios
        .post(API_1 + Global.userInfo, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          this.userInfo = res.data.data
          // this.userInfo.spareusero =
          //   API_1 + Global.imgUrl + this.userInfo.spareusero
        })
        .catch((res) => {
          this.$message.error('发送失败，请稍后再试')
        })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.inp != undefined) {
      this.inpShow = this.inp
    }
    if (tool.getCookie('user')) {
      this.uid = tool.getCookie('user')
      this.token = tool.getCookie('qxchuhai')
      this.getuserInfo()
      this.showuser = true
    } else {
      this.showuser = false
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // setTimeout(() => {
    //   this.maxwidth =
    //     this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth
    // }, 0)
    // document
    //   .getElementsByTagName('html')[0]
    //   .addEventListener('mousemove', this.mouseMoveFn)
    // document
    //   .getElementsByTagName('html')[0]
    //   .addEventListener('mouseup', this.moseUpFn)
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.is-dark {
  margin-top: 30px !important;
  font-size: 14px !important;
}
</style>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.search {
  width: 240px;
  line-height: normal;
}
.el-avatar {
  /deep/ img {
    width: 100%;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.headImg {
  width: 40px;
  height: 40px;
  border: 1px solid #fff;
  border-radius: 50%;
  display: inline-block;
  line-height: 40px;
  //margin-left: 50px;
  //margin-top: 5px;
}
.el-popover {
  .head {
    width: 206px;
    color: #fff;
    background: url('../assets/header.jpg') no-repeat center center;
    padding: 40px 0px 40px 30px;
    margin: -34px 6px 0px -13px;
    border-radius: 6px 6px 0 0;
    div {
      display: inline-block;
      vertical-align: super;
      color: #fff;
      margin-left: 10px;
      .username {
        width: 145px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .list {
    border-radius: 6px;
    padding: 10px 20px 0;

    li {
      margin-bottom: 30px;
      cursor: pointer;
      &:hover {
        color: #0f4d72;
      }
      i {
        width: 16px;
        height: 16px;
        margin-right: 9px;
        display: inline-block;
        font-size: 16px;
        margin-right: 5px;
      }
    }
  }
}
.header {
  background: url('../assets/header.jpg') no-repeat center center;
  background-size: auto;
  height: 60px;
  min-width: 1200px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  text-align: left;
  /deep/.el-input__suffix {
    right: 10px;
  }
  /deep/.el-input__inner:focus {
    border-color: #0f4d72;
  }
  /deep/.el-input__inner {
    // color: #333;
    color: #666;
  }
  /deep/.el-dialog {
    padding: 0 40px;
    text-align: left;
    border-radius: 8px;
    .el-dialog__body {
      padding: 30px 0;
    }
    .drag {
      margin-top: 20px;
      position: relative;
      background-color: #e8e8e8;
      //width: 100%;
      width: 320px;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .handler {
      width: 40px;
      height: 38px;
      border: 1px solid #ccc;
      cursor: move;
    }
    .handler_bg {
      background: #fff
        url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==')
        no-repeat center;
    }
    .handler_ok_bg {
      background: #fff
        url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==')
        no-repeat center;
    }
    .drag_bg {
      background-color: #7ac23c;
      height: 40px;
      width: 0px;
    }
    .drag_text {
      position: absolute;
      top: 0px;
      //width: 100%;
      width: 320px;
      text-align: center;
      -moz-user-select: none;
      -webkit-user-select: none;
      user-select: none;
      -o-user-select: none;
      -ms-user-select: none;
    }

    // .el-input {
    //   width: 223px;
    // }
    .el-input {
      width: 320px;
    }
    .countDown {
      color: red;
      font-size: 16px;
      margin: 0 10px;
    }
    .password {
      .el-input {
        width: 120px;
        margin-right: 10px;
      }
    }
    .login {
      margin-top: 20px;
      width: 320px;
    }
  }
  .box {
    display: inline-block;
    line-height: 60px;
    height: 60px;
    vertical-align: middle;
    //margin-right: 410px; //500
    position: relative;
    // margin-left: 360px;
    /deep/ .el-divider--vertical {
      vertical-align: top;
      height: 40px;
      margin: 0;
    }
    .el-input {
      width: 164px;
      /deep/.el-input__suffix {
        top: 10px;
      }
      /deep/.el-input__inner {
        border-color: transparent;
      }
      /deep/.el-input__inner:hover {
        border-color: transparent;
      }
      /deep/.el-input__inner:focus {
        // border-color: #0f4d72;
        border-color: transparent;
      }
    }

    .el-select {
      width: 75px;
      /deep/.el-input {
        .el-input__inner {
          border-color: transparent;
        }
        .el-input__inner:hover {
          border-color: transparent;
        }
        .el-input__inner:focus {
          // border-color: #0f4d72;
          border-color: transparent;
        }
      }
      /deep/.selected {
        color: #0f4d72;
      }
    }

    .logo {
      display: inline-block;
      margin-right: 30px;
      width: 229px;
      height: 40px;
    }

    .el-button {
      background: transparent;
      // margin-left: 50px;
      color: #fff;
      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid transparent;
      }
    }
  }
  .el-menu--horizontal {
    border-bottom: transparent;
  }
  .el-menu {
    background: transparent;
    width: 625px;
    margin: 0 auto;
    display: inline-block;
    vertical-align: middle;
    li {
      height: 58px;
      line-height: 58px;
      padding: 0 16px;
      color: #fff;
      opacity: 0.8;
      &:hover {
        background: transparent !important;
        border-bottom: 3px solid #fff !important;
        opacity: 1;
      }
    }
  }
}
</style>
